var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-xl": "", fluid: "" } },
    [
      _c("FabricRangeSelector", {
        attrs: {
          type: "Honeycomb Blind",
          value: _vm.selectedFabricGroup,
          v: _vm.$v.selectedFabricGroup,
          error: _vm.$v.selectedFabricGroup.$error
        },
        on: {
          "selected-fabric-group": function($event) {
            _vm.selectedFabricGroup = $event
          }
        }
      }),
      _vm._v(" "),
      _c("FabricSelector", {
        attrs: {
          fabricGroupID: _vm.selectedFabricGroup,
          value: _vm.item.fabric,
          v: _vm.$v.item.fabric,
          error: _vm.$v.item.fabric.$error
        },
        on: {
          "selected-fabric": function($event) {
            _vm.selectedFabric = $event
          }
        }
      }),
      _vm._v(" "),
      _c("ColorSelector", {
        attrs: { fabricID: _vm.selectedFabric, value: _vm.item.color },
        on: {
          "selected-color": function($event) {
            _vm.item.color = $event
          }
        }
      }),
      _vm._v(" "),
      _c("DimensionSelector", {
        ref: "dimensionSelector",
        attrs: {
          valueName: _vm.item.name,
          valueWidth: _vm.item.width,
          valueDrop: _vm.item.drop,
          type: this.item.type
        },
        on: {
          room: function($event) {
            return _vm.setRoom($event)
          },
          ready: function(isReady) {
            return (_vm.readyToSubmitDimension = isReady)
          }
        }
      }),
      _vm._v(" "),
      _c("CustomizationSelector", {
        attrs: {
          title: "Fitting",
          value: _vm.item.variations.fitting,
          options: ["Recess Fit", "Face Fit"],
          v: _vm.$v.item.variations.fitting,
          error: _vm.$v.item.variations.fitting.$error
        },
        on: {
          "selected-option": function($event) {
            _vm.item.variations.fitting = $event
          }
        }
      }),
      _vm._v(" "),
      _c("CustomizationSelector", {
        attrs: {
          title: "Control Side",
          value: _vm.item.variations.controlSide,
          options: ["Left", "Right"],
          v: _vm.$v.item.variations.controlSide,
          error: _vm.$v.item.variations.controlSide.$error
        },
        on: {
          "selected-option": function($event) {
            _vm.item.variations.controlSide = $event
          }
        }
      }),
      _vm._v(" "),
      _c("CustomizationSelector", {
        attrs: {
          title: "Control Type",
          value: _vm.item.variations.controlType,
          options: ["Standard Bottom Up", "Top Down Bottom Up"],
          v: _vm.$v.item.variations.controlType,
          error: _vm.$v.item.variations.controlType.$error
        },
        on: {
          "selected-option": function($event) {
            _vm.item.variations.controlType = $event
          }
        }
      }),
      _vm._v(" "),
      _c("CustomizationSelector", {
        attrs: {
          title: "Rail Colour",
          value: _vm.item.variations.railColor,
          options: ["Anodised Silver", "White"],
          v: _vm.$v.item.variations.railColor,
          error: _vm.$v.item.variations.railColor.$error
        },
        on: {
          "selected-option": function($event) {
            _vm.item.variations.railColor = $event
          }
        }
      }),
      _vm._v(" "),
      _vm.incInstall
        ? _c(
            "div",
            [
              _c("v-checkbox", {
                attrs: { label: "Install?", color: "primary" },
                model: {
                  value: _vm.customInstall,
                  callback: function($$v) {
                    _vm.customInstall = $$v
                  },
                  expression: "customInstall"
                }
              }),
              _vm._v(" "),
              _vm.customInstall
                ? _c("v-text-field", {
                    attrs: { label: "Install Price" },
                    model: {
                      value: _vm.item.installPrice,
                      callback: function($$v) {
                        _vm.$set(_vm.item, "installPrice", $$v)
                      },
                      expression: "item.installPrice"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("v-textarea", {
        attrs: { name: "notes", label: "Line Item Notes" },
        model: {
          value: _vm.item.notes,
          callback: function($$v) {
            _vm.$set(_vm.item, "notes", $$v)
          },
          expression: "item.notes"
        }
      }),
      _vm._v(" "),
      !_vm.edit
        ? _c(
            "v-btn",
            {
              attrs: { color: "primary" },
              on: {
                click: function($event) {
                  return _vm.addItem()
                }
              }
            },
            [_vm._v("Add " + _vm._s(_vm.item.type))]
          )
        : _c(
            "v-btn",
            {
              attrs: { color: "primary" },
              on: {
                click: function($event) {
                  return _vm.addItem()
                }
              }
            },
            [_vm._v("Update " + _vm._s(_vm.item.type))]
          ),
      _vm._v(" "),
      _c("b", [_vm._v("$" + _vm._s(_vm.item.total.toFixed(2)))])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa063f78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa063f78","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/products/HoneycombBlind.vue
// module id = null
// module chunks = 